/** Leitura da prescrição de força (atleta e pré-visualização): exercício, séries e observações. */
import type { StrengthPrescription } from "../api/types";
import { describeSet } from "../lib/strengthEdit";
import { PARAM_LABEL } from "../lib/strength";
import { t } from "../i18n";

export function StrengthView({ value }: { value: StrengthPrescription }) {
  const labels = { kg: t("kg"), rest: t("de descanso"), reps: t("rep.") };
  return (
    <div className="strength-view">
      <ol className="sv-items">
        {value.items.map((item, idx) => (
          <li key={item.key ?? idx} className="sv-item">
            <div className="sv-item-head">
              <strong>{item.name}</strong>
              {item.param_type && <span className="muted">{PARAM_LABEL[item.param_type]}</span>}
            </div>
            {item.description && <p className="muted sv-desc">{item.description}</p>}
            <ol className="sv-sets">
              {item.sets.map((s, k) => (
                <li key={k}>
                  <span className="sv-setno">{t("Série {n}", { n: k + 1 })}</span>
                  <span className="num">{describeSet(s, labels)}</span>
                  {s.note && <span className="muted"> — {s.note}</span>}
                </li>
              ))}
            </ol>
            {item.note && <p className="sv-note">{item.note}</p>}
          </li>
        ))}
      </ol>
      {value.notes && <p className="sv-general" style={{ whiteSpace: "pre-wrap" }}>{value.notes}</p>}
    </div>
  );
}
